import { render, staticRenderFns } from "./SupporterEditPaymentDetails.vue?vue&type=template&id=2472481c&"
import script from "./SupporterEditPaymentDetails.vue?vue&type=script&lang=js&"
export * from "./SupporterEditPaymentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2472481c')) {
      api.createRecord('2472481c', component.options)
    } else {
      api.reload('2472481c', component.options)
    }
    module.hot.accept("./SupporterEditPaymentDetails.vue?vue&type=template&id=2472481c&", function () {
      api.rerender('2472481c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/supporters/views/Donations/SupporterEditPaymentDetails.vue"
export default component.exports